import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=3b1ecc69"
import script from "./table-view.ts?vue&type=script&lang=ts&external"
export * from "./table-view.ts?vue&type=script&lang=ts&external"
import style0 from "./table-view.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1ecc69')) {
      api.createRecord('3b1ecc69', component.options)
    } else {
      api.reload('3b1ecc69', component.options)
    }
    module.hot.accept("./table-view.vue?vue&type=template&id=3b1ecc69", function () {
      api.rerender('3b1ecc69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overview/table-view/table-view.vue"
export default component.exports